import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "~/contexts/AuthContext";
import { useLoader } from "~/contexts/LoaderContext";

function ProtectedRoute({ children, requiredRoles, area }) {
    const { user, admin, loading } = useAuth();
    const location = useLocation();
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        if (loading) {
            showLoader();
            return () => hideLoader();
        }
    }, [loading, showLoader, hideLoader]);

    // Determine which user session to check based on the area
    const currentUser = area === "AdminArea" ? admin : user;

    if (loading) {
        return null;
    }

    if (!currentUser) {
        const redirectUrl = encodeURIComponent(location.pathname + location.search);
        if (area === "AdminArea") return <Navigate to={`/auth/admin-signin?redirect=${redirectUrl}`} replace />;
        return <Navigate to={`/auth/signin?redirect=${redirectUrl}`} replace />;
    }

    if (area === "AdminArea" && currentUser.Area === "UserArea") {
        return <Navigate to="/ai-chatbot/chat" replace />;
    }

    // Role-based access control can be added here if needed using requiredRoles

    return children;
}

export default ProtectedRoute;
